var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [
            _c("h4", {
              domProps: {
                innerHTML: _vm._s(_vm.title || _vm.sectionToEdit.label)
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close(false)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            !_vm.sectionToEdit
              ? _c("div", [_vm._v("Wähle aus was du bearbeiten möchtest.")])
              : [
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "employment-mode"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.employmentMode,
                          "initial-show-all": "",
                          "label-type": "application",
                          "show-multiple-hint": ""
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "function"
                    ? _c("Functions", {
                        attrs: { "employment-modes": _vm.employmentModes },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "function-assistance"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.functionAssistance,
                          "characteristic-type":
                            _vm.meta.functionAssistanceType,
                          "nothing-allowed": {
                            text: "Egal - es sind alle Tätigkeiten erwünscht"
                          },
                          "initial-show-all": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "function-marketing-role"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items":
                            _vm.meta.functionMarketingRole,
                          "characteristic-type":
                            _vm.meta.functionMarketingRoleType,
                          "nothing-allowed": {
                            text: "Egal - es sind alle Tätigkeiten erwünscht"
                          },
                          "initial-show-all": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "function-legal-field"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.functionLegalField,
                          "characteristic-type":
                            _vm.meta.functionLegalFieldType,
                          "nothing-allowed": {
                            text: "Egal - es sind alle Rechtsgebiete erwünscht"
                          },
                          "initial-show-all": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "function-legal-role"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.functionLegalRole,
                          "characteristic-type": _vm.meta.functionLegalRoleType,
                          "nothing-allowed": {
                            text:
                              "Egal - es sind alle Rechtstätigkeiten erwünscht"
                          },
                          "initial-show-all": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "function-tax-field"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.functionTaxField,
                          "characteristic-type": _vm.meta.functionTaxFieldType,
                          "nothing-allowed": {
                            text: "Egal - es sind alle Steuergebiete erwünscht"
                          },
                          "initial-show-all": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "function-tax-role"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.functionTaxRole,
                          "characteristic-type": _vm.meta.functionTaxRoleType,
                          "nothing-allowed": {
                            text:
                              "Egal - es sind alle Steuertätigkeiten erwünscht"
                          },
                          "initial-show-all": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "working-time"
                    ? _c("WorkingTime", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "home-office"
                    ? _c("HomeOffice", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "geo"
                    ? _c("Geo", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "career-level"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          "characteristic-items": _vm.meta.careerLevel,
                          "initial-show-all": "",
                          "show-multiple-hint": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "industrial-sector"
                    ? _c("IndustrialSectors", {
                        attrs: {
                          "nothing-allowed": _vm.industrialSectorsNothingAllowed
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "organisational-area"
                    ? _c("OrganisationalArea", {
                        attrs: { functions: _vm.job.functions },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "salary"
                    ? _c("Salary", {
                        attrs: { "employment-modes": _vm.employmentModes },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "hourly-rate"
                    ? _c("HourlyRate", {
                        attrs: { "employment-modes": _vm.employmentModes },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "working-hours"
                    ? _c("WorkingHours", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "employment-duration"
                    ? _c("EmploymentDuration", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "start-date"
                    ? _c("StartDate", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "search-status"
                    ? _c("SearchStatus", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "parking"
                    ? _c("Parking", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "public-transport"
                    ? _c("PublicTransport", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "private-vehicle-company-usage"
                    ? _c("PrivateVehicleCompanyUsage", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "company-car"
                    ? _c("CompanyCar", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "customer-contact"
                    ? _c("CustomerContact", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit &&
                  _vm.sectionToEdit.id === "travel-willingness"
                    ? _c("TravelWillingness", {
                        attrs: { meta: _vm.meta },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "company-type"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          multiple: "",
                          "initial-show-all": "",
                          "characteristic-items": _vm.meta.companyType,
                          "nothing-allowed": {
                            text: "Egal - alle sind möglich"
                          },
                          "show-multiple-hint": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "company-size"
                    ? _c("CharacteristicSelectInline", {
                        attrs: {
                          multiple: "",
                          "initial-show-all": "",
                          "characteristic-items": _vm.meta.companySize,
                          "nothing-allowed": {
                            text: "Egal - alle sind möglich"
                          },
                          "show-multiple-hint": "",
                          "label-type": "application"
                        },
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "management"
                    ? _c("Management", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "overtime"
                    ? _c("Overtime", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sectionToEdit && _vm.sectionToEdit.id === "relocation"
                    ? _c("Relocation", {
                        model: {
                          value: _vm.sectionData,
                          callback: function($$v) {
                            _vm.sectionData = $$v
                          },
                          expression: "sectionData"
                        }
                      })
                    : _vm._e()
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _vm.sectionToEdit
              ? _c("Button", {
                  attrs: {
                    text: "Speichern",
                    disabled: !_vm.sectionDataValid || _vm.saving,
                    loading: _vm.saving,
                    icon: "checkmark"
                  },
                  on: { click: _vm.save }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }